import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'acc-card',
    imports: [],
    templateUrl: './card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './card.component.css'
})
export class CardComponent {

  @Input()
  public class: string = '';

  @Input()
  public border: boolean = false;

  @Input()
  public size: 'sm' | undefined;
}
